







































































import {
  BButton, BModal, BForm, BFormInput, BFormGroup, BSpinner, BFormTextarea, BFormCheckbox
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateFonction } from '@/api/models/authorization/fonctions/fonction';
import { required, min, max } from '@validations'

@Component({
  components: {
    BButton, 
    BModal, 
    BForm, 
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
  },
})

export default class AddFonctionModal extends Vue {
  @Prop({ required: false, default: "Ajout d'une fonction" }) title!: string
  @Prop({ required: true }) loading!: boolean
  @Prop({ required: true }) allowRang!: boolean

  required = required;
  min = min;
  max = max;

  newFonction: CreateFonction = {}

  async createFonction(event: any) {
    event.preventDefault();
    (this.$refs.formValidation as InstanceType<typeof ValidationObserver>)
      .validate()
      .then((isSuccess) => {
        if (isSuccess) {
          this.$emit('add-fonction', this.newFonction);
        }
      })
  }
}
